import React, { useState, useEffect } from 'react'
import { urlKey } from '../../../services/api/api-urls'
import { getColModelItem, getItemsObj, getRandomKey, renderFn } from '../../../services/lib/utils/helpers'
import { Button, Select, Tooltip } from 'antd'
import CommonDatePickerFilter from '../../../components/common/others/common-date-picker-filter'
import moment from 'moment'
import { FilePdfOutlined } from '@ant-design/icons'
import { EditOutlined } from '@material-ui/icons'
import IProdtipsForCustomer from '../../../components/common/i-tips/customerProd'
import { ApiRequest } from '../../../services/api/api'

export const colKey: any = {
  customerId: 'customerId',
  customerNumber: 'customerNumber',
  company: 'company',
  customerCode: 'customerCode',
  salutation: 'salutation',
  contactPerson: 'contactPerson',
  address1: 'address1',
  address2: 'address2',
  postalCode: 'postalCode',
  phone: 'phone',
  mobile: 'mobile',
  email: 'email',
  leadRating: 'leadRating',
  notes: 'notes',
  deliveryFeeFlag: 'flag',
  city: urlKey.City,
  customerGroup1: urlKey.CustomerGroup1,
  customerGroup2: urlKey.CustomerGroup2,
  customerGroup3: urlKey.CustomerGroup3,
  customerGroup4: urlKey.CustomerGroup4,
  customerGroup5: urlKey.CustomerGroup5,
  customerStatus: urlKey.CustomerStatus,
  customerSource: urlKey.CustomerSource,
  paymentCycle: urlKey.PaymentCycle,
  employee: urlKey.Employee,
  brand: urlKey.Brand,
  deliveryMethod: urlKey.DeliveryMethod,
  customerCredit:'customerCredit',
  showPriceOnPackingSlip:'showPriceOnPackingSlip'
}
  const selectOption = [
    { id: true,name: 'Yes' },
    { id: false, name: 'No' },
  ];
const keyInfosArray: any = () => {
  return [
    {key: colKey.customerNumber, label: 'Customer Number', otherOptions: {disabled: true}},
    {key: colKey.company, label: 'Company',otherOptions: {required: true, width: '16rem'}},
    {key: colKey.customerCode, label: 'Trading Name', otherOptions: {required: true, width: '16rem'}},
    {key: colKey.salutation, label: ' Name'},
    {key: colKey.city, label: 'City', otherOptions: {type: 'select', width: '14rem'}},
    {key: colKey.address1, label: 'Company Address', otherOptions: {type: 'googleMapAddrSelect', width: '14rem'}},
    {key: colKey.postalCode, label: 'Postal Code', otherOptions: {width: '14rem'}},
    {key: colKey.phone, label: 'Notes',otherOptions: {type: 'inputTextArea'}},
    {key: colKey.mobile, label: 'Mobile',otherOptions: {type: 'inputTextArea',required: true}},
    {key: colKey.email, label: 'Email',otherOptions: {type: 'inputTextArea',required: true}},
    {key: colKey.customerCredit, label: 'Credit Limit',otherOptions: {type: 'inputNumber'}},
    {key: colKey.customerGroup1, label: 'Group1', otherOptions: {type: 'select',required: true}},
    {key: colKey.customerGroup2, label: 'Group2', otherOptions: {type: 'select',required: true}},
    {key: colKey.customerGroup3, label: 'Group3', otherOptions: {type: 'select'}},
    {key: colKey.customerGroup4, label: 'Group4', otherOptions: {type: 'select'}},
    {key: colKey.customerGroup5, label: 'Group5', otherOptions: {type: 'select'}},
    {key: colKey.leadRating, label: 'Rating', otherOptions: {type: 'inputNumber', max: 5}},
    {key: colKey.paymentCycle, label: 'Payment Term', otherOptions: {type: 'select',required: true}},
    {key: colKey.customerStatus, label: 'Status', otherOptions: {type: 'select',required: true}},
    {key: colKey.employee, label: 'Sales', otherOptions: {type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['firstName', 'lastName'],required: true}},
    {key: colKey.brand, label: 'Brand', otherOptions: {type: 'select',required: true, width: '16rem'}},
    {key: colKey.customerSource, label: 'Source', otherOptions: {type: 'select',required: true}},
    {key: colKey.deliveryMethod, label: 'Delivery Method', otherOptions: {type: 'select', width: '14rem'}},
    {key: colKey.notes, label: 'Active/Deactive Note', otherOptions: {type: 'inputTextArea'}},
    {key: colKey.deliveryFeeFlag, label: 'Delivery Fee', otherOptions:  {type: 'select',
        isOverrideSelectionOptions: true,
        valueJoinArray: ['flagName'],
        selectionGetUrl: '/DeliveryMethod/GetAllDeliveryFeeFlags', width: '14rem'
        }},
    {key: colKey.showPriceOnPackingSlip, label: 'Show Price On PackingSlip', otherOptions: {type: 'fixedSelect',rowDataKeyword:"showPriceOnPackingSlip",options:selectOption}},
  ]
}

const colInfos: any = (isSalesCustomer: any) => ({
  companyInfo: {
    title: 'Customer Info',
    field: 'customerCode',
    keywords: [
      colKey.customerNumber,
      colKey.company,
      colKey.customerCode,
      colKey.brand,
      colKey.notes,
    ],
    render: [
      colKey.customerCode,
      // <IProdtipsForCustomer id={colKey.customerId} label={colKey.customerCode}></IProdtipsForCustomer>
    ]
  },
  contactInfo: {
    title: 'Contact Info',
    field: 'contactInfo',
    keywords: [
      colKey.salutation,
      colKey.phone,
      colKey.mobile,
      colKey.email,
    ],
    render: [
      colKey.phone,
    ],
    // 列收窄：内容过长时在单元格内自动换行，而不是把整列撑宽。
    // maxWidth 需容纳编辑态最宽控件（phone/mobile/email 的 TextArea 为 16rem），
    // 否则编辑时会溢出单元格、与右侧 Address Info 列重叠
    cellStyle: { whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '18rem' },
  },
  addressInfo: {
    title: 'Address Info',
    field: 'addressInfo',
    keywords: [
      colKey.city,
      colKey.address1,
      colKey.postalCode,
      colKey.deliveryMethod,
      colKey.deliveryFeeFlag
    ],
    render: [
      colKey.address1,
    ]
  },
  groupClassification: {
    title: 'Group Classification',
    field: 'groupClassification',
    keywords: [
      colKey.customerGroup1,
      colKey.customerGroup2,
      colKey.customerGroup3,
      colKey.customerGroup4,
      // colKey.customerGroup5,
      colKey.showPriceOnPackingSlip
    ],
    render: [
      colKey.customerGroup1,
    ]
  },
  otherInfo: {
    title: 'Other Info',
    field: 'otherInfo',
    keywords: isSalesCustomer ? [
      colKey.customerSource,
    ] : [
      colKey.paymentCycle,
      colKey.customerCredit,   
      colKey.customerSource,
      colKey.employee,
      // colKey.leadRating,
      colKey.customerStatus,
    ],
    render: [
      colKey.employee,
    ]
  }
})

const CustomerManagementColumnModel = (props: any): any => {
  let modelArr: any = [
    colInfos(props.isSalesCustomer).companyInfo,
    colInfos(props.isSalesCustomer).contactInfo,
    colInfos(props.isSalesCustomer).addressInfo,
    colInfos(props.isSalesCustomer).groupClassification,
    // colInfos(props.isSalesCustomer).otherInfo,  // 对于 customer-only-sales 也显示 otherInfo
  ]
  if (!props.isSalesCustomer) {
    modelArr.push(colInfos(props.isSalesCustomer).otherInfo)
  }

  // 应用 getColModelItem 到所有列
  modelArr = modelArr.map((row: any) => ({
    ...getColModelItem(row, keyInfosArray),
    render: (rowData: any) => {
      if (row.field === 'customerCode') {
        return <IProdtipsForCustomer id={rowData[colKey.customerId]} label={rowData[colKey.customerCode]}></IProdtipsForCustomer>
      }
      if (row.field === 'contactInfo') {
        return rowData[colKey.phone]
      }
      if (row.field === 'addressInfo') {
        return rowData[colKey.address1]
      }
      if (row.field === 'groupClassification') {
        return rowData.group1?.group1Name
      }
      if (row.field === 'otherInfo') {
        return rowData.employee?.firstName + ' ' + rowData.employee?.lastName
      }
      return renderFn(getItemsObj(keyInfosArray(), rowData), row.render)
    },
  }))
 
  modelArr.push(
    {
      title: 'Created At',
      field: 'createdAt',
      type: 'datetime',
      // hidden: !props.isSalesCustomer,  // customer-only-sales 页面显示此列
      hiddenByColumnsButton: true,
      editable: 'never',
      render: (rowData: any) =>rowData.createdAtDate?moment.utc( rowData.createdAtDate).local().format('DD/MM/YYYY'):'',
      filterComponent: (props:any) => {
        return (
          <>
            <CommonDatePickerFilter
              columnDef={props.columnDef}
              onFilterChanged={props.onFilterChanged}
            />
          </>
        )
      },
      customFilterAndSearch: (
        filterValue:any,
        rowData:any
      ) => {
        // material-table 会把右上角全局搜索框的文本作为 filterValue 传入；
        // 本列只处理日期范围对象，纯文本交给其它列匹配（返回 false 即可）
        if (typeof filterValue !== 'object' || filterValue === null) return false
        // 未设置过滤条件时不过滤；行数据为空且设置了条件时不匹配
        if (!filterValue || (!filterValue.startDate && !filterValue.endDate)) return true
        if (!rowData.createdAt) return false

        // 将 UTC 时间转换为本地时间后按天比较（单边条件按单边过滤）
        const localDateTime = moment.utc(rowData.createdAt).local()
        const localDate = localDateTime.format('YYYY-MM-DD')

        return (!filterValue.startDate || localDate >= filterValue.startDate) &&
               (!filterValue.endDate || localDate <= filterValue.endDate)
      },
    }
  )
  modelArr.push(
    {
      title: 'Last Order',
      field: 'lastOrderDate',
      type: 'datetime',
      // hidden: !props.isSalesCustomer,  // customer-only-sales 页面显示此列
      hiddenByColumnsButton: true,
      editable: 'never',
      render: (rowData: any) =>rowData.lastOrderDate?moment.utc( rowData.lastOrderDate).local().format('DD/MM/YYYY'):''
    })
  if (!props.isSalesCustomer && props.isSalesView != true) {
    modelArr.push({
      title: 'Status Change',
      field: 'statusId',
      editable: 'never',
      lookup: {
        1: 'Active',
        2: 'Prospect',
        3: 'Lead',
        4: 'On hold',
        5: 'Lost',
        6: 'Close',
        7: 'Unconfirmed'
      },
      // customFilterAndSearch: (filterValue: any, rowData: any) => {
      //   // If filterValue is an array, it's the status dropdown filter
      //   if (Array.isArray(filterValue)) {
      //     return filterValue.includes(rowData.status?.statusId?.toString());
      //   }
      //   // If filterValue is a string (general search), let other columns handle it
      //   return true;
      // },
      render: (rowData: any) => {
        // 根据状态ID返回对应的背景颜色
        const getStatusColor = (statusId: number) => {
          const colorMap: { [key: number]: string } = {
            1: '#52c41a',    // Active - 绿色
            2: '#1890ff',    // Prospect - 蓝色
            3: '#722ed1',    // Lead - 紫色
            4: '#faad14',    // On hold - 橙色
            5: '#f5222d',    // Lost - 红色
            6: '#8c8c8c',    // Close - 灰色
            7: '#fa8c16'     // Unconfirmed - 深橙色
          };
          return colorMap[statusId] || '#8c8c8c'; // 默认灰色
        };

        const statusId = rowData.status?.statusId;
        const backgroundColor = statusId !== undefined ? getStatusColor(statusId) : '#8c8c8c';

        return (
          <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
            {/* 显示当前状态 */}
            {/* 药丸形状态标签：浅色底 + 状态色文字 + 同色细边框（GitHub label 风格） */}
            <div style={{
              display: 'inline-block',
              padding: '3px 10px',
              borderRadius: '999px',
              fontSize: '12px',
              fontWeight: 500,
              whiteSpace: 'nowrap',
              backgroundColor: backgroundColor + '22',
              color: backgroundColor,
              border: '1px solid ' + backgroundColor + '55'
            }}>
              {rowData.status?.statusName || 'Unknown'}
            </div>
            {/* 与 work order Comments 列一致的编辑图标样式 */}
            <Tooltip title="Change Status">
              <Button
                key={getRandomKey()}
                size="small"
                type="text"
                style={{ display: 'inline-flex', alignItems: 'center', height: 'auto', padding: 0, marginLeft: 2, verticalAlign: 'middle' }}
                onClick={() => {
                  props.updateCustomerStatus(rowData, undefined)
                }}
                icon={<EditOutlined style={{ fontSize: 15, color: '#1a3d2e' }} />}
              />
            </Tooltip>
          </div>
        );
      }
    })
  } else {
    modelArr.push({
      title: 'Status',
      field: 'customerStatus',
      editable: 'never',
      // defaultFilter: 'Active',
      customFilterAndSearch: (
        filterValue: any,
        rowData: any
      ) => {
        if (!filterValue) return true;
        return filterValue?.substring(0, 3)?.toLowerCase() === rowData?.status?.statusName?.substring(0, 3).toLowerCase();
      },
      render: (rowData: any) => rowData.status?.statusName,
    })
  }

  return modelArr
}

// 自定义状态过滤器组件
const StatusFilter = (props: any) => {
  const [statusOptions, setStatusOptions] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchStatusOptions = async () => {
      setLoading(true)
      try {
        const response = await ApiRequest({
          url: 'CustomerStatus/GetAllCustomerStatus',
          method: 'get',
          isShowSpinner: false
        })
        setStatusOptions(response?.data?.data || [])
      } catch (error) {
        console.error('Failed to fetch customer statuses:', error)
        // 如果 API 失败，使用默认状态选项
        setStatusOptions([
          { statusId: 1, statusName: 'Active' },
          { statusId: 2, statusName: 'Inactive' }
        ])
      } finally {
        setLoading(false)
      }
    }

    fetchStatusOptions()
  }, [])

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Select statuses"
      value={props.columnDef.tableData.filterValue || []}
      onChange={(value) => props.onFilterChanged(props.columnDef.tableData.id, value)}
      loading={loading}
      allowClear
    >
      {statusOptions.map((status: any) => (
        <Select.Option key={status.statusId} value={status.statusId}>
          {status.statusName}
        </Select.Option>
      ))}
    </Select>
  )
}

export default CustomerManagementColumnModel
